/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: <Ravi Ranjan Kumar,  Mylavarapu Sarath Sai, Amal Sabu, sanket, Ujjwal Singh >

*/
import { client, syncClient } from "./";
import {
  saveBulkImages,
  getImages,
  bulKDeleteImages,
  //  getImageById,
} from "database/offlineDb/indexDb";
import { isTerminalReservationLocalRow } from "realtime/bulkReservationRows";
import { getAuthTokenFromSessionStorage } from "helpers/common";

export const saveOrUpdateBulkImgList = (imgList) => (dispatch) => {
  let response = dispatch({
    type: "ADD_BULK_IMG",
    payload: saveBulkImages(imgList),
  });
  return response;
  // return function (dispatch) {
  //     savePatient(data)
  //         .then((response) => {
  //             dispatch({
  //                 type: 'ADD_PATIENT_DATA_FULFILLED',
  //                 payload: response
  //             })
  //         })
  // }
};
export const getBulkImgList = () => (dispatch) => {
  let response = dispatch({
    type: "GET_BULK_IMG",
    payload: getImages(),
  });
  return response;
};

// export const getBulkImgListById=(id)=>dispatch=> {
//     let response=dispatch({
//         type: 'GET_BULK_IMG_BY_ID',
//         payload: getImageById()
//       })
//     return response
// }
// -----for store-----

export function createBulkImageListData(value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_BULK_IMAGE_LIST",
      payload: value,
    });
  };
}
export function selectedBulkImageListData(value) {
  return (dispatch) => {
    dispatch({
      type: "SELECTED_BULK_IMAGE_LIST",
      payload: value,
    });
  };
}
export function updateBulkImgListByID(value) {
  // console.log("value", value);
  return (dispatch) => {
    dispatch({
      type: "UPDATE_BULK_IMAGE_LIST_BY_ID",
      payload: value,
    });
  };
}
export function removeBulkImgByID(value) {
  return (dispatch) => {
    dispatch({
      type: "REMOVE_BULK_IMAGE_BY_ID",
      payload: value,
    });
  };
}
export function triggerBulkReportCountAlert(payload) {
  return {
    type: "TRIGGER_BULK_REPORT_COUNT_ALERT",
    payload,
  };
}

export const deleteBulkImagesAction = (imgList) => {
  return async (dispatch) => {
    try {
      const localRows = imgList.filter(isTerminalReservationLocalRow);
      if (localRows.length) {
        if (localRows.length !== imgList.length) return;
        await bulKDeleteImages(Array.from(new Set(localRows.map((row) => row.guid))));
        const images = await getImages();
        dispatch({
          type: "DELETE_IMAGES_FROM_IDB_AND_STORE_FULFILLED",
          payload: images,
        });
        return;
      }

      const guidList = imgList.map((row) => row.guid);
      const result = await client.post(
        "/img-delete",
        { guidList },
        { headers: { authorization: getAuthTokenFromSessionStorage() } }
      );

      result &&
        bulKDeleteImages(result.data.guidList)
          .then((res) => {
            dispatch({
              type: "DELETE_IMAGES_FROM_IDB_AND_STORE",
              payload: getImages(),
            });
          })
          .catch((err) => console.log(err));
    } catch (err) {
      console.log({ error: err });
    }
  };
};

// This action will only be used for users where their organisation has review_all_cases flag is enabled.
export const triggerReview = (payload) => async (dispatch) => {
  const { rows, setSnackbarErrorMsg } = payload;
  const authToken = getAuthTokenFromSessionStorage();
  try {
    const rowsToTriggerReviewFor = [];
    const guidsForReview = [];
    rows.forEach((imgRow) => {
      const review = imgRow?.status?.[0]?.review;
      if (!review || String(review) === "0" || review === 0) {
        console.log("imgRow", imgRow);
        rowsToTriggerReviewFor.push(imgRow);
        guidsForReview.push(imgRow.guid);
      }
    });
    const res = await client.post(
      "/review",
      { guidsForReview },
      {
        headers: {
          Accept: "*/*",
          authorization: authToken,
        },
      }
    );
    rowsToTriggerReviewFor.forEach((row) => {
      row.status[0] = { ...row.status[0], review: 1 };
    });

    await dispatch({
      type: "GET_VIEW_IMAGE_FULFILLED",
      payload: saveBulkImages(rowsToTriggerReviewFor),
    });
  } catch (error) {
    console.log("bulk upload action review trigger error", error);
    setSnackbarErrorMsg(
      error?.response?.data?.msg ||
        "Error While Triggering The  Review in bulk upload"
    );
  }
};
